<div class="ui container">
  <div class="ui stackable grid">
    <div class="row">
      <div class="seven wide column">
        <h1>
          Bounties List
        </h1>
      </div>
      <div class="eight wide right floated column">
        <div class="ui grid">
          <div class="eight wide column pr-0">
            <button class="ui fluid black button show-info-button"
              (click)="showInstructions = !showInstructions">
              <i class="caret down icon"></i>
              How does it work?
            </button>
          </div>
          <div class="eight wide column">
            <button class="ui right floated fluid green button"
              [routerLink]="'/bounties/create'">
              <i class="plus icon"></i> Create Bounty
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ui grid instructions-section" *ngIf="showInstructions">
    <div class="column">
      <div class="ui inverted segment">
        <p>
          A bounty is a challenge that can be completed
          by any player to win a reward.
        </p>
        <p>
          Bounties may have requirements such as FC'ing a map,
          setting a high score, etc.
        </p>
        <p>
          Anyone can create a bounty as long as they have a
          valid osu account and profile on this website.
          All users must be verified in-game so that their
          accounts on this website
          are linked to their osu! account.
        </p>
        <p>
          When someone has taken on a bounty challenge and
          achieved the requirements, they may submit a
          claim to the reward, which the Creator (or an admin)
          will then accept.
        </p>
        <p>
          It is up to the Creator of the bounty to pay the
          winner. We hold no responsibility for ensuring
          payments are actually made,
          but in the event that a dispute arrises, we will
          endeavour to ban users that do not
          honour their bounty rewards.
        </p>
        <p>
          Bounty Creators who pay out their winners will be
          rewarded with points for each bounty
          they successfully pay out. This should help players to
          see which bounties can
          be most relied upon to receive the reward for.
        </p>
        <p>
          We will also attempt to remove any users we suspect
          have created bounties
          with no intention of paying out the reward, or people
          that troll the system otherwise.
        </p>
      </div>
    </div>
  </div>

  <div class="ui filters section">
    <div class="ui doubling stackable grid">
      <div class="six wide computer ten wide tablet column">
        <div class="ui inverted secondary pointing menu">
          <a *ngFor="let tab of allTabs" class="item"
            [class.active]="activeTab === tab" (click)="changeTab(tab)">
            {{tab | titlecase}}
            <div class="ui circular label">
              {{ tabsCount(tab) }}
              <i class="fitted spinner circle loading icon"
                *ngIf="activeCount === undefined"></i>
            </div>
          </a>
        </div>
      </div>
      <div class="four wide computer six wide tablet column">
        <div class="ui category search item search-container">
          <div class="ui fluid inverted icon input">
            <input #searchInputEl="ngModel" type="text"
              placeholder="Search..." [(ngModel)]="searchInput">
            <i class="inverted search link icon"></i>
          </div>
        </div>
      </div>
      <div class="six wide computer sixteen wide tablet column">
        <div class="ui stackable grid">
          <div class="nine wide column pr-0">
            <div class="ui left floated inverted header sort-dropdown-container"
              (click)="toggleSortSelect()">
              <div class="content">
                Sort:
                <sui-select class="inline sort-dropdown" icon="dropdown"
                  transitionDuration="100" #filterSelect
                  placeholder="Sort by...." [(ngModel)]="selectedSort"
                  [options]="sortableFields" [labelField]="'label'"
                  [valueField]="'value'" (ngModelChange)="onFiltersChanged()">
                  <div class="header">Sort By</div>
                  <sui-select-option *ngFor="let o of filterSelect.filteredOptions"
                    [value]="o"></sui-select-option>
                </sui-select>
                <i class="dropdown icon"></i>
              </div>
            </div>
          </div>
          <div class="seven wide computer four wide tablet right floated column">
            <button class="ui right floated fluid button show-filters-button"
              (click)="toggleFiltersSection()">
              Filters <i class="fitted dropdown icon"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <app-bounties-filters [selectedFilters]="selectedFilters"
      (filtersCleared)="resetFilters()" (filterRemoved)="removeFilter($event)"
      (filterAdded)="addFilter($event)" [searchTerm]="searchTerm"
      (searchCleared)="clearSearch()">
    </app-bounties-filters>
  </div>

  <div *ngIf="!bounties" class="ui basic very padded segment">
    <div class="ui inverted active centered inline huge text loader">
      Loading bounties...
    </div>
  </div>

  <div *ngIf="!bounties && !fetching || (bounties && !bounties.length)"
    class="ui inverted segment">
    <i>No bounties found with the applied filters...</i>
  </div>

  <div class="ui doubling stackable three column desktop two column tablet relaxed grid bounties-list">
    <div class="column bounty-column" *ngFor="let bounty of bounties">
      <app-bounty-card [bounty]="bounty" [isListing]="true">
      </app-bounty-card>
    </div>
  </div>

  <div *ngIf="fetching" class="ui segment basic very padded">
    <div class="ui active loader blue"></div>
  </div>
</div>
